import {API_ADMIN_URL, ANALYSER_URL} from '../../../config/constants'
import { postRequest } from '../../API'

/*********************************************************
* Function Name : List
* Description   : Get list of all lotto winners
* By            : Afsar Ali
* Date          : 20-01-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : aggregatedList
* Description   : Get list of all lotto winners aggregated list
* By            : Afsar Ali
* Date          : 06-01-2026 
*********************************************************/
export const aggregatedList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/aggregated-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : uploadWinners
* Description   : upload Lotto winner
* By            : Afsar Ali
* Date          : 20-01-2024 
*********************************************************/
export const uploadWinners = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/upload-winner`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : createWinners
* Description   : upload Lotto winner
* By            : Afsar Ali
* Date          : 28-04-2024 
*********************************************************/
export const createWinners = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/create-winner`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : winnersSummery
* Description   : upload Lotto winner
* By            : Afsar Ali
* Date          : 20-01-2024 
*********************************************************/
export const winnersSummery = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/winner-summery`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : winnersSummery
* Description   : upload Lotto winner
* By            : Afsar Ali
* Date          : 21-01-2024 
*********************************************************/
export const changeBatchStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/batch-change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : deleteBatch
* Description   : delete Lotto winner
* By            : Afsar Ali
* Date          : 21-01-2024 
*********************************************************/
export const deleteBatch = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/batch-delete`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : upload Lotto winner
* By            : Afsar Ali
* Date          : 21-01-2024 
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : deleteData
* Description   : delete Lotto winner
* By            : Afsar Ali
* Date          : 21-01-2024 
*********************************************************/
export const deleteData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/delete`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : bulkChangeStatus
* Description   : upload Lotto winner
* By            : Afsar Ali
* Date          : 21-01-2024 
*********************************************************/
export const bulkChangeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/bulk-change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : bulkDeleteData
* Description   : delete Lotto winner
* By            : Afsar Ali
* Date          : 21-01-2024 
*********************************************************/
export const bulkDeleteData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/bulk-delete`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : analizeWinners
* Description   : this function is used to analyse users
* By            : Afsar Ali
* Date          : 22-03-20245
*********************************************************/
export const analizeWinners = async (options) =>{
    try {
        const params = {
            url : `${ANALYSER_URL}./v1/admin/analyzer/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : analyzeWinnersList
* Description   : this function is used to analyse users
* By            : Afsar Ali
* Date          : 16-04-2025
*********************************************************/
export const analyzeWinnersList = async (options) =>{
    try {
        const params = {
            url : `${ANALYSER_URL}./analyzersingle-match`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {
                status : true, 
                result : { 
                    finaldata : res?.data?.data || [],
                    total_data : res?.data?.total_data || 0,
                    total_pages : res?.data?.total_pages || 0,
                    current_page : res?.data?.current_page || 1,
                    total_ticket : res?.data?.data[0]?.total_ticket || 0
                }
            };
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : getOrderReports
* Description   : upload Lotto winner
* By            : Afsar Ali
* Date          : 22-04-2024 
*********************************************************/
export const getOrderReports = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/order/reports`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : reverseRedeemTicket
* Description   : reverse winning tickets
* By            : Afsar Ali
* Date          : 05-01-2026 
*********************************************************/
export const reverseRedeemTicket = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/reverse-redeem`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
